import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
    disabledLink: PropTypes.bool,
    sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {

    // OR
    const logo = <Box component="img" src="https://www.italcambio.com/images/Logo_Italcambio.png"
        // const logo = <Box component="img" src="http://100.24.13.117/Logo_Italcambio.png"

        sx={{ width: 80, height: 80, ...sx }} />

    if (disabledLink) {
        return <>{logo}</>;
    }

    return <RouterLink to="/">{logo}</RouterLink>;
}
